export default "__VITE_ASSET__8eb7658b__"